export const MAX_INLINE_CATEGORIES = 12;
export const LONG_OPTION_LENGTH = 20;
